export const isExternalUrl = (url: string) =>
  /^https?:\/\//i.test(url) || url.startsWith('//');
